<template>
    <div style="width: 100%; height: 100%">
        <GMapMap
            :center="center"
            :zoom="15"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
            :options="options"
            ref="gmap"
        >
            <GMapCircle
                :radius="Number('300')"
                :center="center"
                :options="circleOptions"
            />
            <GMapMarker
                :position="center"
                :icon="{
                    url: propertyListingImageUrl,
                    scaledSize: { width: 100, height: 100 },
                    anchor: { x: 50, y: 50 },
                }"
            ></GMapMarker>
        </GMapMap>
    </div>
</template>

<script>
export default {
    name: "ListingGoogleMaps",

    props: {
        type: {
            type: String,
            required: true,
        },
        geoinfo: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            zoom: 13,
            paths: [],
            center: {
                lat: Number(this.geoinfo.lat),
                lng: Number(this.geoinfo.lng),
            },
            options: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                gestureHandling: "none",
            },
            circleOptions: {
                strokeColor: "D8D8D8",
                strokeOpacity: 0.1,
                strokeWeight: 1,
                fillColor: "D8D8D8",
                fillOpacity: 0.1,
            },
        };
    },
    mounted() {},
    computed: {
        propertyListingImageUrl() {
            if (this.type == "zimmer")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/room-location-pin-listing.png"
                );
            if (this.type == "haus")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/house-location-pin-listing.png"
                );
            if (this.type == "wohnung")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/apartment-location-pin-listing.png"
                );
            if (this.type == "grundstueck")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/land-location-pin-listing.png"
                );
            if (this.type == "hausbau")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/house-location-pin-listing.png"
                );
            if (this.type == "ind_Schl_3259")
                return (
                    this.$assetsUrl +
                    "/images/gmaps-icons/apartment-location-pin-listing.png"
                );

            return "";
        },
    },
    methods: {},
};
</script>
